export default __webpack_public_path__ + "static/media/green_street.ea777960.jpg";